import { ArrowUpRight, Building2, Globe, Mail, Phone, User } from "lucide-react";
import { FadeUp } from "@/components/landing/Reveal";

const ClubFin = () => (
    <div data-testid="clubfin-page" className="min-h-screen bg-[#F9FAFB] flex flex-col">
        <header className="bg-[#0A0A0A] noise-overlay">
            <div className="max-w-3xl mx-auto px-6 md:px-12 py-10 text-center">
                <p data-testid="clubfin-logo" className="font-heading text-white text-3xl font-black tracking-tight">
                    Club-Fin<span className="text-[#FF6B00]">.nl</span>
                </p>
            </div>
        </header>

        <main className="flex-1 max-w-xl w-full mx-auto px-6 md:px-12 py-14 md:py-20 space-y-8">
            <FadeUp className="rounded-2xl bg-white border border-black/10 p-7">
                <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#0047FF] mb-3">Wie zijn wij</p>
                <p data-testid="clubfin-about" className="text-[#0A0A0A]/70 text-sm leading-relaxed">
                    <span className="block font-heading font-bold text-[#0A0A0A] text-base tracking-tight mb-1.5">Wat doet Club-Fin.nl?</span>
                    Club-Fin.nl biedt voor verenigingen, stichtingen en andere organisaties software-producten aan voor een beter inzichtelijke financiële planning.
                </p>
            </FadeUp>

            <FadeUp delay={0.05} className="rounded-2xl bg-white border border-black/10 p-7">
                <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#FF6B00] mb-5">Over Ed</p>
                <div className="flex flex-col sm:flex-row gap-6 items-start">
                    <img
                        data-testid="clubfin-ed-foto"
                        src="/images/ed.jpg"
                        alt="Ed van Wijk, oprichter Club-Fin.nl"
                        className="w-32 sm:w-36 aspect-[4/5] object-cover object-top rounded-xl shadow-md shrink-0"
                    />
                    <p data-testid="clubfin-ed" className="text-[#0A0A0A]/70 text-sm leading-relaxed">
                        Als geoloog maakte ik 40 jaar geleden kennis met Monte Carlo simulaties, in de vele
                        jaren daarna ben ik veel met de ontwikkeling van modelleringssoftware bezig geweest.
                        De afgelopen jaren
                        heb ik me nuttig geprobeerd te maken bij verenigingen: watersport, natuur- en
                        landschapsbescherming, en nu havenconcerten. Daar viel me op dat het niet simpel was
                        om meerjarenbegrotingen te maken — of met over-ingewikkelde Excel files, of met een
                        dure accountant naast je. Dus bouwde ik er zelf een: onafhankelijk, supersnel,
                        betaalbaar en gemakkelijk — gemaakt voor de vrijwilligers die het echte werk doen.
                        <span className="block mt-3 font-heading font-bold text-[#0A0A0A] tracking-tight">— Ed van Wijk</span>
                    </p>
                </div>
            </FadeUp>

            <FadeUp delay={0.08} className="rounded-2xl bg-[#0A0A0A] noise-overlay p-7">
                <div className="flex items-center gap-3 mb-3">
                    <Globe className="w-4 h-4 text-[#FF6B00] shrink-0" />
                    <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#FF8A3D]">Onze service</p>
                </div>
                <p className="font-heading text-white font-bold text-xl tracking-tight">MeerjarenplanOnline.nl</p>
                <p className="mt-1.5 text-white/50 text-sm leading-relaxed">
                    Investment scenario's AI voor verenigingen, stichtingen en professionals — een service van Club-Fin.nl.
                </p>
                <a
                    data-testid="clubfin-service-link"
                    href="https://meerjarenplanonline.nl"
                    className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#0047FF] hover:bg-[#0036CC] text-white font-bold px-6 py-3 text-sm transition-[background-color,transform] duration-300 hover:scale-[1.04]"
                >
                    Bezoek MeerjarenplanOnline.nl
                    <ArrowUpRight className="w-4 h-4" />
                </a>
            </FadeUp>

            <FadeUp delay={0.15} className="rounded-2xl bg-white border border-black/10 p-7">
                <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#0047FF] mb-5">Contact</p>
                <div className="space-y-3.5">
                    <p data-testid="clubfin-contact-name" className="flex items-center gap-3 text-[#0A0A0A]/80">
                        <User className="w-4 h-4 text-[#FF6B00] shrink-0" />
                        <span className="text-sm font-bold">Ed van Wijk</span>
                    </p>
                    <a data-testid="clubfin-contact-email" href="mailto:info@club-fin.nl" className="flex items-center gap-3 text-[#0A0A0A]/80 hover:text-[#0A0A0A] transition-colors">
                        <Mail className="w-4 h-4 text-[#FF6B00] shrink-0" />
                        <span className="text-sm font-bold">info@club-fin.nl</span>
                    </a>
                    <a data-testid="clubfin-contact-phone" href="tel:+31653218125" className="flex items-center gap-3 text-[#0A0A0A]/80 hover:text-[#0A0A0A] transition-colors">
                        <Phone className="w-4 h-4 text-[#FF6B00] shrink-0" />
                        <span className="text-sm font-bold">06 5321 8125</span>
                    </a>
                    <p data-testid="clubfin-contact-kvk" className="flex items-center gap-3 text-[#0A0A0A]/80">
                        <Building2 className="w-4 h-4 text-[#FF6B00] shrink-0" />
                        <span className="text-sm font-bold">KvK: 42158680</span>
                    </p>
                </div>
            </FadeUp>
        </main>

        <footer className="border-t border-black/10">
            <p data-testid="clubfin-copyright" className="max-w-3xl mx-auto px-6 md:px-12 py-6 text-center text-[#0A0A0A]/40 text-xs tracking-wide">
                Copyright: 2026 Club-Fin.nl. Alle rechten voorbehouden.
            </p>
        </footer>
    </div>
);

export default ClubFin;
